module.exports = __webpack_public_path__ + "img/new_logo.eb88592b.png";